import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Box, Grid, Typography, Container, Divider, Stack, Button, } from "@mui/material";
import Link from "@shared/components/contents/link/Link";
import { useFooter } from "@shared/hooks/SectionHook";
import Social from "../Social";
import generateTemplatePropsFromContents from "@frontoffice/utils/templates/generateTemplatePropsFromContents";
import useCookieStore from "@shared/store/CookieStore";
import { useSites } from "@shared/hooks/SiteHook";
import useGlobalStore from "@shared/store/GlobalStore";
import LinkEditor from "@administration/components/editor/LinkEditor";
import { useMemo } from "react";
const footerStyled = {
    width: "100%",
    bgcolor: "background.footer",
    display: "flex",
    py: "80px",
};
const logoStyled = {
    "& img": {
        height: "auto",
        width: { xs: "200px", md: "250px" },
    },
};
const Footer = () => {
    const { isBo } = useGlobalStore((state) => ({ isBo: state.isBo }));
    const { handleCookiesModal } = useCookieStore((state) => ({
        handleCookiesModal: state.handleCookiesModal,
    }));
    const { currentSite: site = {} } = useSites();
    const { settings: siteSettings } = site?.contents
        ? generateTemplatePropsFromContents(site?.contents)
        : site;
    const { copyright = "", logoFooter } = siteSettings || {};
    const { footer } = useFooter(site?.id);
    const footerContents = useMemo(() => {
        return (footer && generateTemplatePropsFromContents(footer.contents)) || {};
    }, [footer]);
    const linkInternals = useMemo(() => {
        return Object.keys(footerContents || {}) || [];
    }, [footerContents]);
    const socialNetworks = useMemo(() => {
        let { socialNetworks: socialNetworksFinded = [] } = siteSettings || {};
        if (!socialNetworksFinded || socialNetworksFinded.length === 0)
            return null;
        if (socialNetworksFinded && !Array.isArray(socialNetworksFinded)) {
            return [socialNetworksFinded];
        }
        return socialNetworksFinded;
    }, [siteSettings]);
    const LinkRender = isBo ? LinkEditor : Link;
    const LinkList = useMemo(() => {
        if (!linkInternals || linkInternals.length === 0)
            return null;
        return linkInternals
            .filter((linkInternal, index) => footerContents[linkInternal] && index < 2)
            .map((linkInternal) => (_jsx(Grid, { size: { xs: 6, md: 3 }, children: _jsx(Stack, { spacing: 1.5, children: (Array.isArray(footerContents[linkInternal])
                    ? footerContents[linkInternal]
                    : [footerContents[linkInternal]]).map((list1item) => (_createElement(LinkRender, { ...list1item.link, key: list1item.id, sx: {
                        color: "primary.contrastText",
                        fontSize: "16px",
                        fontWeight: 500,
                    } }, list1item.title))) }) }, linkInternal)));
    }, [LinkRender, footerContents, linkInternals]);
    return (_jsx(Box, { component: "footer", sx: footerStyled, children: _jsxs(Container, { sx: { maxWidth: "1208px !important", py: { xs: "40px", md: "64px" } }, children: [_jsxs(Grid, { container: true, spacing: 4, justifyContent: "space-between", children: [LinkList, _jsx(Grid, { size: { xs: 12, md: linkInternals.length > 1 ? 3 : 6 }, children: _jsxs(Stack, { spacing: 2, alignItems: { xs: "center", md: "flex-end" }, children: [_jsx(Box, { sx: logoStyled, children: logoFooter ?? (_jsx("img", { alt: "logo docaposte", src: "/logo-docaposte-agility-white.svg", width: 250 })) }), copyright && (_jsxs(Typography, { variant: "body1", sx: { color: "primary.contrastText" }, children: ["\u00A9 ", copyright] }))] }) })] }), _jsx(Divider, { sx: {
                        my: { xs: 4, md: 7 },
                    } }), socialNetworks && (_jsx(Stack, { direction: { xs: "column", sm: "row" }, spacing: 3, sx: {
                        alignItems: "center",
                        mb: { xs: 4, md: 7 },
                        "& a": {
                            color: "primary.contrastText",
                            fontSize: "16px",
                            fontWeight: 500,
                        },
                    }, children: _jsx(Social, { socialNetworks: socialNetworks }) })), _jsxs(Stack, { direction: { xs: "column", sm: "row" }, spacing: 3, sx: { alignItems: "center" }, children: [linkInternals
                            .filter((linkInternal, index) => footerContents[linkInternal] && index >= 2)
                            .flatMap((linkInternal) => {
                            return (Array.isArray(footerContents[linkInternal])
                                ? footerContents[linkInternal]
                                : [footerContents[linkInternal]]).map((list1item) => (_createElement(LinkRender, { ...list1item.link, key: list1item.id, sx: {
                                    color: "primary.contrastText",
                                } }, list1item.title)));
                        }), _jsx(Button, { onClick: () => handleCookiesModal(), size: "medium", sx: {
                                cursor: "pointer",
                                color: "primary.contrastText",
                                fontWeight: "normal",
                                p: "0 0 0 24px",
                                ":hover": {
                                    textDecoration: "underline",
                                },
                                "::after": {
                                    display: "none",
                                },
                            }, children: "Cookies" })] })] }) }));
};
export default Footer;
